import React, { useEffect, useState, } from 'react'
import { Link, useParams } from 'react-router-dom'
import styled from 'styled-components'

import sanitizeHtml from 'sanitize-html';

import nlnAxios from '../../api/nlnAxios'
import { useDispatch } from 'react-redux'
import { createCollection } from '../features/collections/collectionSlice'

// import { useSelector, useDispatch } from 'react-redux'

// import { getResourceByNLN } from '../features/resources/resourceSlice'

import { NavBar } from '../../components/navbar'
import { Button } from '../../components/button'


const ArticlePage = () => {
    const {resourceNlnCode} = useParams()
    const dispatch = useDispatch()

    const [resources, setResources ] = useState()
    const [addCollection, setAddCollection ] = useState()
    const [ loading, setLoading ] = useState()
    const [error, setError ] = useState()
    const [errorMessage, setErrorMessage] = useState()

    useEffect(() => {
        let mounted = true;
        const getResourceByNLN = async () => {
          try {
            const response = await fetch(
                
                ("https://nigeriana-api-staging.herokuapp.com/api/v1/library/public/resources/?NLNCode=" + resourceNlnCode ),
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );
            const data = await response.json();
            setResources(data?.data?.foundResource);
            setLoading(false);
          } catch (error) {
            setError(true);
            setErrorMessage(error.message);
            setLoading(false);
          }
        };
        if (mounted) {
            getResourceByNLN();
        }
        return () => {
          mounted = false;
        }; 
      }, []);

      const onAdd = ()=> {
        // setAddCollection(resources?.resourceId)
        dispatch(createCollection(resources.resourceId))
    }
   
  return (
    <Container>
        <NavBar />

        <ContentBody>
                <h2>{resources?.resourceTitle}</h2>
                

                <div>

                
                    <LeftAside>
                        <ContentAbout>

                            {
                                resources?.resourceAuthor !== ''
                                ?<h4>Author(s): <span>{resources?.resourceAuthor}</span></h4> 
                                : null
                            }

                            {
                                resources?.resourceISBN !== ''
                                ?<h4>ISBN Number: {resources?.resourceISBN}</h4>
                                :null
                            }

                            {
                                resources?.resourceEdition !== ''
                                ?<h4>Resource Edition: <span>{resources?.resourceEdition}</span></h4>
                                :null
                            }
                            
                            {
                                resources?.resourcePublisher !== ''
                                ?<h4>Resource Publisher: <span>{resources?.resourcePublisher}</span></h4>
                                : null
                            }

                            {
                                resources?.resourcePublishDate !== ''
                                ?<h4>Date Published: <span>{resources?.resourcePublishDate}</span></h4>
                                : null
                            }
                            


                        </ContentAbout>

                        <ContentArticle>

                            <p dangerouslySetInnerHTML={{ __html: sanitizeHtml(resources?.resourceDescription) }} />
                           
                            
                        </ContentArticle>

                        <MoreDetails>
                            <h6>Contacts: <div>{resources?.resourceContacts}</div></h6>
                            {/* <h6>Contacts: <div>{resources?.resourceImprint}</div></h6>
                            <h6>Contacts: <div>{resources?.resourceContacts}</div></h6> */}
                        </MoreDetails>
                        

                    </LeftAside>

                    <RightAside>

                            <Download>
                                {/* <h4>Download</h4> */}

                                {/* <Button filled bgColor={'#2A870E'} noIcon text={'Link to resource'} /> */}
                                <a href={resources?.resourceRepositoryLink} target='_blank' >Link to resource</a>
                                {/* <div> {resources?.resourceImage} </div> */}
                            </Download>

                            <AddToCollection onClick={ onAdd } > 
                                + Add to my collection
                            </AddToCollection>

                            <OtherLinks> 

                                {/* <NavLink to='/advanced-search'>
                                    Search for more articles 
                                </NavLink> */}

                                <NavLink to='/nigeriana'>
                                    New arrivals 
                                </NavLink>
                                
                                <NavLink to='/open-access-resources'>
                                    Open access resources
                                </NavLink>    

                            </OtherLinks>

                            <Tags>
                                <small> {resources?.resourceTagName} </small>
                                
                            </Tags>



                    </RightAside>


                </div>
                
                

        </ContentBody>
    </Container>
  )
}

const Container = styled.main`


`

const ContentBody = styled.section`
    width: 100%;
    max-width: 1250px;
    margin: 0 auto;
    padding: 50px 0;

    & > div {
        display: flex;
        justify-content: space-between;

        @media screen and (max-width: 768px) {
            flex-direction: column;
        }
    }

`

const LeftAside = styled.aside`
    /* flex: 2.5; */
    width: 65%;
    margin-right: 2rem;

    @media screen and (max-width: 768px) {
            padding: 15px;
            width: 100%;
            margin-right: 0rem;
        }
`

const MoreDetails = styled.div`
    display: flex;
    flex-direction: column;

`

const ContentAbout = styled.div`
    align-self: left;
    margin-top: 3rem;

    @media screen and (max-width: 768px) {
            margin-top: 0rem;
        }

    & > h4 {
        font-weight: 600;

        & > span {
            font-weight: 400;
            font-size: 1.4rem;
        }
    }
`

const ContentArticle = styled.div`

    margin-top: 3rem;
    /* border: 1px solid; */
`

const RightAside = styled.aside`
    /* flex: 1; */
    width: 30%;
    position: sticky;

    @media screen and (max-width: 768px) {
        position: relative;
        width: 100%;
        
    }

`

const Download = styled.div`
    border: 1px solid #D0D5DD;
    padding: 3.2rem 2rem;
    color: #101828;
    filter: drop-shadow(0px 4px 8px rgba(255, 255, 255, 0.25)) drop-shadow(0px 4px 15px rgba(0, 0, 0, 0.15));
    border-radius: 4px;
    

    & > a{
        margin-top: 2rem;
        height: 40px;
        padding: 20px 40px;
        font-family: "Metropolis", sans-serif;
        font-size: 1.6rem;
        color: #fff;
        background-color: #2A870E;
        border-radius: 4px;
        border: none;
        outline: none;
        width: fit-content;
        text-align: center;
        cursor: pointer;

        &:hover {
        background-color: #fff;
        color: #2A870E;
        
        border: 2px solid #2A870E;
        transition: all 0.2s ease-in-out;
  }
        @media (max-width: 768px) {
            padding: 10px 15px;
            font-size: 13px !important;
            & > span {
            font-size: 10px !important;
            }
        }
    }

    & > h4 {
        font-size: 2rem;
        font-weight: 600;
    }

    & > button {
        margin-top: 2rem;
        height: 40px;
    }

`


const AddToCollection = styled.h4`
    font-weight: 600;
    font-size: 1.6rem;
    margin-top: 2rem;
    padding: 1.2rem 3rem;
    width: fit-content;
    background-color: #EAECF0;
    border-radius: 4px;
    cursor: pointer;
    

    :hover {
        transition: ease-in-out 0.2s;
        opacity: 0.7;
    }
    

`

const OtherLinks = styled.div`

    display: flex;
    flex-direction: column;
    margin-top: 2rem;

    & :last-child{
        border-bottom: 1px solid #e5e5e5;
    }

    @media screen and (max-width: 768px) {
            padding: 15px;
            width: 100%;
            margin-right: 0rem;
        }

`

const NavLink = styled(Link)`
    color: #101828;
    font-size: 1.6rem;
    /* width: max-content; */
    padding-top: 1rem;
    padding-bottom: 1rem;
    border-top: 1px solid #e5e5e5;
    
`

const Tags = styled.div`

    border: 1px solid #D0D5DD;
    padding: 3.2rem 2rem;
    color: #101828;
    filter: drop-shadow(0px 4px 8px rgba(255, 255, 255, 0.25)) drop-shadow(0px 4px 15px rgba(0, 0, 0, 0.15));
    border-radius: 4px;
    margin-top: 2rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1rem;

    & > small {
        font-style: italic;
        font-size: 1.2rem;
        padding: 0.8rem;
        background-color: #fff;
        cursor: pointer;
        border-radius: 4px;
    }

`

export {ArticlePage}